import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import ui from "beercss"
import "material-dynamic-colors"

// Initialize BeerCSS
window.addEventListener("DOMContentLoaded", () => {
  const toggleButton = document.getElementById("theme-toggle");
  
  // Get saved theme, default to dark
  const savedTheme = localStorage.getItem("theme");
  let currentTheme = savedTheme || "dark";

  // Helper function to update UI
  function updateTheme(theme) {
    ui("mode", theme);
    const icon = toggleButton.querySelector("i");
    icon.textContent = theme === "dark" ? "light_mode" : "dark_mode";
  }

  // Apply initial theme
  updateTheme(currentTheme);

  // Toggle theme on button click
  toggleButton.addEventListener("click", () => {
    currentTheme = currentTheme === "dark" ? "light" : "dark";
    localStorage.setItem("theme", currentTheme);
    updateTheme(currentTheme);
  });
})

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Site loaded!")
